module.exports = __webpack_public_path__ + "img/kleidi-2.2cb1a9a6.png";